import type { IntakeCondition, IntakeQuestion } from "@bloom/shared";
const input = "w-full rounded-lg border border-gray-300 p-2 text-sm";
export function IntakeConditionsEditor({
  questions,
  value,
  onChange,
}: {
  questions: IntakeQuestion[];
  value: IntakeCondition[];
  onChange: (value: IntakeCondition[]) => void;
}) {
  return (
    <div className="space-y-2">
      {value.map((c, i) => {
        const q = questions.find((q) => q.id === c.questionId);
        const patch = (changes: Partial<IntakeCondition>) =>
          onChange(value.map((v, j) => (i === j ? { ...v, ...changes } : v)));
        return (
          <div key={i} className="grid gap-2 sm:grid-cols-3">
            <select
              aria-label="Condition question"
              className={input}
              value={c.questionId}
              onChange={(e) => {
                const q = questions.find((q) => q.id === e.target.value);
                patch({
                  questionId: e.target.value,
                  operator: "eq",
                  value:
                    q?.type === "boolean"
                      ? true
                      : q?.type === "number"
                        ? 0
                        : q?.choices?.[0] || "",
                });
              }}
            >
              <option value="">Choose question</option>
              {questions
                .filter((q) => q.required)
                .map((q) => (
                  <option key={q.id} value={q.id}>
                    {q.prompt || q.id}
                  </option>
                ))}
            </select>
            <select
              aria-label="Condition operator"
              className={input}
              value={c.operator}
              onChange={(e) =>
                patch({
                  operator: e.target.value as IntakeCondition["operator"],
                })
              }
            >
              <option value="eq">Equals</option>
              {q?.type === "number" && (
                <>
                  <option value="gte">At least</option>
                  <option value="lte">At most</option>
                </>
              )}
            </select>
            {q?.type === "number" || q?.type === "text" ? (
              <input
                aria-label="Condition value"
                className={input}
                type={q.type === "number" ? "number" : "text"}
                value={String(c.value)}
                onChange={(e) =>
                  patch({
                    value:
                      q.type === "number"
                        ? Number(e.target.value)
                        : e.target.value,
                  })
                }
              />
            ) : (
              <select
                aria-label="Condition value"
                className={input}
                value={String(c.value)}
                onChange={(e) =>
                  patch({
                    value:
                      q?.type === "boolean"
                        ? e.target.value === "true"
                        : e.target.value,
                  })
                }
              >
                {q?.type === "boolean" ? (
                  <>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </>
                ) : (
                  q?.choices?.map((c) => <option key={c}>{c}</option>)
                )}
              </select>
            )}
            <button
              type="button"
              className="text-sm text-red-700 text-left"
              onClick={() => onChange(value.filter((_, j) => i !== j))}
            >
              Remove condition
            </button>
          </div>
        );
      })}
      <button
        type="button"
        className="rounded-lg border px-3 py-2 text-sm"
        onClick={() =>
          onChange([...value, { questionId: "", operator: "eq", value: true }])
        }
      >
        Add condition
      </button>
    </div>
  );
}
